/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css, CSSProperties } from 'styled-components';
import { ColumnProps } from 'components/common/cpds/cpds-grid-system/typings';

// Helper function to get the column span value for grid
const getGridColumn = (col: number | { span: number, offset?: number } | undefined) => {
  if (typeof col === 'object' && col?.span !== undefined) {
    return `span ${col.span}`;
  }
  if (typeof col === 'number') {
    return `span ${col}`;
  }
  return 'span 12'; // Default to full width if no span is provided
};

// Helper function to get the column offset value for grid
const getGridOffset = (col: { span?: number, offset?: number } | undefined) => {
  if (typeof col === 'object' && col?.offset !== undefined) {
    return col.offset + 1; // The +1 accounts for grid starting at 1, not 0
  }
  return 1; // No offset by default
};

export const Column = styled.div.attrs<ColumnProps>(({ dataCy, className, ...props }) => { 
  return {
    'data-cy': dataCy,
    className: className,
  };
}) <ColumnProps>`
  padding-right: ${({ gutter }) => gutter ? `calc(${gutter} / 2)` : '0px'};
  padding-left: ${({ gutter }) => gutter ? `calc(${gutter} / 2)` : '0px'};

  /* Default grid setup */
  grid-column: ${({ colSm }) => getGridColumn(colSm)};
  grid-column-start: ${({ colSm }) => getGridOffset(colSm)};

  /* Small devices - screen width ≥ 768px */
  @media (min-width: 768px) {
    grid-column: ${({ colMd }) => getGridColumn(colMd)};
    grid-column-start: ${({ colMd }) => getGridOffset(colMd)};
  }

  /* Medium devices - screen width ≥ 1440px */
  @media (min-width: 1440px) {
    grid-column: ${({ colLg }) => getGridColumn(colLg)};
    grid-column-start: ${({ colLg }) => getGridOffset(colLg)};
  }

  /* Large devices - screen width ≥ 1680px */
  @media (min-width: 1680px) {
    grid-column: ${({ colXl }) => getGridColumn(colXl)};
    grid-column-start: ${({ colXl }) => getGridOffset(colXl)};
  }

  /* Apply styleOverrides if passed */
  ${({ styleOverrides }) => styleOverrides && css`
    ${Object.entries(styleOverrides).map(([key, value]) => {
      if (key.startsWith('@media')) {
        return `
          ${key} {
            ${Object.entries(value as CSSProperties).map(([prop, val]) => `${prop}: ${val};`).join('')}
          }
        `;
      } else {
        return `${key}: ${value};`;
      }
    }).join('')}
  `}
`;